import script from "./SfxContextMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxContextMenu.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QMenu,QList,QItem,QItemSection,QIcon});qInstall(script, 'directives', {Ripple});
